<template>
  <Modal v-model="visible" title="选择行业标签" width="800" :mask-closable="false" @on-ok="submit" @on-cancel="visible = false">
    <div class="select-post">
      <div class="right">
        <div class="tips">
          <div class="tips-content">
            <div class="tips-left">已选行业</div>
            <div class="tips-right">
              <span style="color: #f21b18">{{ threelevel.length }}</span>
              / {{ maxLimit }}
            </div>
          </div>
          <div style="font-size: 12px; color: #aaa; padding-top: 10px">请选择行业,最多3个</div>
        </div>
        <div v-show="threelevelList.length" class="tags">
          <div class="tags-title">已选择</div>
          <div class="tags-content">
            <div class="tag" v-for="(item, index) in threelevelList" :key="index" @click="delect(index)">
              {{ item.name }}
              <span>X</span>
            </div>
          </div>
        </div>
        <div class="scroll" :class="{ 'not-only': !only }">
          <Collapse v-if="postTree">
            <Panel v-for="(iteq, index) in postTree" :name="String(index)" :key="index" class="right-list">
              {{ iteq.name }}
              <template #content>
                <div class="right-item" v-show="iteq.children">
                  <div
                    @click="selectPost(idx, iv)"
                    class="items"
                    v-for="(iv, idx) in iteq.children"
                    :key="idx"
                    :class="{ 'select-item': threelevel.includes(iv.id) }"
                  >
                    {{ iv.name }}
                  </div>
                </div>
              </template>
            </Panel>
          </Collapse>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
export default {
  props: {
    onConfirm: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      visible: false,
      firstLevel: 0,
      threelevel: [],
      threelevelList: [],
      maxLimit: 3,
      postTree: [],
      only: 1,
      type: '' // User | Company
    };
  },
  methods: {
    open(options) {
      this.visible = true;
      if (options.type) {
        this.type = options.type;
      } else {
        this.visible = false;
        return;
      }
      this.threelevel = [];
      this.threelevelList = JSON.parse(JSON.stringify(options.industry || []));
      this.threelevelList.map(item => {
        this.threelevel.push(item.id);
      });
      if (options.maxLimit) {
        this.maxLimit = parseInt(options.maxLimit);
      }
      this.getTree();
    },
    submit() {
      if (this.threelevelList.length) {
        this.visible = false;
        this.$emit('onConfirm',this.threelevelList);
      } else {
        this.$Message.error({
          content: '请选择行业标签'
        });
      }
    },
    getTree() {
      this.$axios.request({ url: 'front/v1/industry-front/getTree' }).then(res => {
        if (res.data) {
          this.postTree = res.data || [];
        }
      });
    },
    selectPost(index, iv) {
        let idx = this.threelevel.indexOf(iv.id);
        if (idx !== -1) {
          this.threelevel.splice(idx, 1);
          this.threelevelList.splice(idx, 1);
        } else {
          if (this.threelevelList.length >= this.maxLimit) {
            this.$Message.error({
              content: `可以选择最多${this.maxLimit}个`
            });
            return;
          }
          this.threelevelList.push(iv);
          this.threelevel.push(iv.id);
        }
    },
    delect(idx) {
      this.threelevel.splice(idx, 1);
      this.threelevelList.splice(idx, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.select-post {
  padding-top: 16px;
  .right {
    margin-left: 15px;
    .right-list {
      margin-bottom: 40px;
      .right-title {
        font-size: 16px;
        color: #333;
        font-weight: 600;
        margin-bottom: 2px;
      }
      .right-item {
        display: flex;
        flex-wrap: wrap;
        .items {
          width: 116px;
          border: 1px solid #eee;
          color: #333;
          font-size: 14px;
          border-radius: 8px;
          margin: 8px 8px 0 0;
          padding: 10px 5px;
          text-align: center;
          cursor: pointer;
          box-sizing: border-box;
        }
        .select-item {
          background: #feeded;
          color: #f32926;
          border: none;
        }
      }
    }
  }
  .scroll {
    height: 400px;
    overflow-y: auto;
  }
  .not-only {
    height: 300px;
  }
}

.tips {
  margin-bottom: 40px;
  margin-right: 15px;
  .tips-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tips-left {
      font-size: 20px;
      color: #333;
      font-weight: 600;
    }
  }
}

.tags {
  display: flex;
  flex-direction: column;
  margin: 12px 0 40px;
  &-title {
    font-size: 16px;
    color: #333;
    font-weight: 600;
  }
  &-content {
    display: flex;
    flex-wrap: wrap;
  }
  .tag {
    display: flex;
    align-items: center;
    width: max-content;
    height: 21px;
    background: #feeded;
    border-radius: 4px;
    padding: 2px 8px;
    font-size: 12px;
    color: #f21b18;
    margin-right: 24px;
    margin-top: 8px;
    cursor: pointer;
    span {
      margin-left: 10px;
    }
  }
}
</style>
